<div class="pointCF__field">
  <label
    ppTooltip
    class="pointCF__label"
    ppTitle="{{ ppCustomField?.label }}"
    [ppTrimTooltip]="true"
  >
    <img class="pointCF__bulk-changes-field-icon" [src]="EIconPath.CUSTOM_FIELD_TIME_ACTIVITY" />

    <span class="pointCF__label-container">
      {{ ppCustomField?.label }}
    </span>
  </label>

  <div
    class="pointCF__content"
    ppTooltip
    [ppTitle]="ppCustomField.lockedValue ? ('locked_by_admin' | ppTranslate) : ''"
  >
    <pp-custom-field-time
      [ppReadOnly]="disabled"
      [ppField]="ppCustomField"
      (ppUpdate)="updateTime($event, ppCustomField)"
    ></pp-custom-field-time>
  </div>
</div>
